var map = {
	"./AliciaLi.jpg": "EKVl",
	"./DrDX.jpg": "2GHw",
	"./DrKL.jpg": "GII8",
	"./DrLMS.jpg": "KXE6",
	"./DrPenny.jpg": "oU5Z",
	"./DrRT.jpg": "Ygg8",
	"./DrZJ.jpg": "qCy1",
	"./MrJsL.jpg": "bTj9",
	"./MrMjL.jpg": "29vA",
	"./MrTJing.jpg": "4SKx",
	"./MrYCQ.jpg": "1Y/2",
	"./ProfPW.jpg": "tTCj",
	"./aboutBg1.jpg": "YK2x",
	"./aboutImg1.jpg": "A+GU",
	"./awards.jpg": "TqdY",
	"./bg.jpg": "dZ/S",
	"./contactImg1.jpg": "bKxZ",
	"./discoveryIconGroup.jpg": "1b4j",
	"./discoveryPageBG1.jpg": "qj41",
	"./discoveryPageBG2.jpg": "CLmA",
	"./globalPartner/1.jpg": "4FbQ",
	"./globalPartner/10.jpg": "5TwM",
	"./globalPartner/11.jpg": "OJZR",
	"./globalPartner/12.jpg": "+ccq",
	"./globalPartner/13.jpg": "y6Po",
	"./globalPartner/14.jpg": "6cHO",
	"./globalPartner/15.jpg": "rkeO",
	"./globalPartner/16.jpg": "nFc8",
	"./globalPartner/17.jpg": "5m14",
	"./globalPartner/18.jpg": "6/o2",
	"./globalPartner/19.jpg": "Iew8",
	"./globalPartner/2.jpg": "mwzy",
	"./globalPartner/20.jpg": "8Ahw",
	"./globalPartner/21.jpg": "K5F8",
	"./globalPartner/22.jpg": "e9hx",
	"./globalPartner/23.jpg": "yu04",
	"./globalPartner/24.jpg": "u2oZ",
	"./globalPartner/25.jpg": "r2u7",
	"./globalPartner/3.jpg": "zlMN",
	"./globalPartner/4.jpg": "6Msz",
	"./globalPartner/5.jpg": "HQDL",
	"./globalPartner/6.jpg": "KtLg",
	"./globalPartner/7.jpg": "Al16",
	"./globalPartner/8.jpg": "UijE",
	"./globalPartner/9.jpg": "IFO5",
	"./globalPartner/logo1.jpg": "EGg+",
	"./globalPartner/logo2.jpg": "UIpq",
	"./globalPartner/logo3.jpg": "gqz6",
	"./project1.jpg": "nt0z",
	"./project2.jpg": "oc7L",
	"./project3.jpg": "wbQq",
	"./project4.jpg": "xgVq",
	"./project5.jpg": "a+js",
	"./projectBG1.jpg": "O4Xu",
	"./t$eImg1.jpg": "8kcp",
	"./t$eImg2.jpg": "ob8+",
	"./t$eImg3.jpg": "ipHS",
	"./t$eImg4.jpg": "ZS3A",
	"./t$eImg5.jpg": "pNJD",
	"./t$ePageBG1.jpg": "rvDS",
	"./tempHeadImg.jpg": "6aeF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vvha";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.jpg$
// module id = vvha
// module chunks = 0